import React from 'react';
import { useSidebarContext } from '@nxsys/context/AppContextProvider/SidebarContextProvider';
import { StyledAppLogo } from './index.styled';

type AppLogoProps = {
  hasSidebarColor?: boolean;
};
const AppLogo: React.FC<AppLogoProps> = ({ hasSidebarColor }) => {
  const { sidebarColorSet } = useSidebarContext();
  return (
    <StyledAppLogo>
      {hasSidebarColor && sidebarColorSet.mode === 'dark' ? (
        <img src="/assets/images/logo-white-with-name.svg" alt="nxsys-logo" />
      ) : (
        <img src="/assets/images/logo-with-name.svg" alt="nxsys-logo" />
      )}
    </StyledAppLogo>
  );
};

export default AppLogo;
